import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.array.map";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React, { useState, useEffect } from 'react';
import Text from '../../../Atoms/Text/Text';
import MoneyBox from '../MoneyBox/MoneyBox';
import { handleDonateSubmission, isAmountValid } from '../../../../utils/Membership';
import { Button, Copy, Error, FormFieldset, FormWrapper, Label, Form, MoneyBuys, AmountField, OuterFieldset, Legend } from '../Donate.style';
import GivingSelector from '../GivingSelector/GivingSelector';

var Signup = function Signup(_ref) {
  var _ref$data = _ref.data,
      singleGiving = _ref$data.singleGiving,
      regularGiving = _ref$data.regularGiving,
      donateLink = _ref.donateLink,
      otherDescription = _ref.otherDescription,
      clientID = _ref.clientID,
      cartID = _ref.cartID,
      mbshipID = _ref.mbshipID,
      rest = _objectWithoutProperties(_ref, ["data", "donateLink", "otherDescription", "clientID", "cartID", "mbshipID"]);

  var _useState = useState('single'),
      _useState2 = _slicedToArray(_useState, 2),
      givingType = _useState2[0],
      setGivingType = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      errorMsg = _useState4[0],
      setErrorMsg = _useState4[1];

  var _useState5 = useState(' '),
      _useState6 = _slicedToArray(_useState5, 2),
      amountDonate = _useState6[0],
      setAmountDonate = _useState6[1];

  var _useState7 = useState(true),
      _useState8 = _slicedToArray(_useState7, 2),
      moneyBuyCopy = _useState8[0],
      setMoneyBuyCopy = _useState8[1];

  useEffect(function () {
    var givingData = givingType === 'single' ? singleGiving : regularGiving;
    setAmountDonate(parseFloat(givingData.moneybuys[1].value));
  }, [givingType, singleGiving, regularGiving]);
  useEffect(function () {
    var givingData = givingType === 'single' ? singleGiving : regularGiving;
    var moneyBuyNewDescription = otherDescription;
    givingData.moneybuys.map(function (moneyBuy, index) {
      if (moneyBuy.value === amountDonate) {
        moneyBuyNewDescription = moneyBuy.description;
      }

      return index === 1 && amountDonate === ' ' && (setMoneyBuyCopy(moneyBuy.description), setAmountDonate(parseFloat(moneyBuy.value)));
    });

    if (!isAmountValid(amountDonate)) {
      if (moneyBuyCopy) setMoneyBuyCopy(false);
      if (!errorMsg) setErrorMsg(true);
    } else {
      if (errorMsg) setErrorMsg(false);
      setMoneyBuyCopy(moneyBuyNewDescription);
    }
  }, [errorMsg, moneyBuyCopy, singleGiving, regularGiving, givingType, amountDonate, otherDescription]);

  var submitDonation = function submitDonation(event, amount, clientId, cartId, mbshipId, donateURL) {
    event.preventDefault();

    if (isAmountValid(amount) && !errorMsg) {
      handleDonateSubmission(amount, clientId, cartId, mbshipId, donateURL, givingType);
    } else {
      setErrorMsg(true);
      setMoneyBuyCopy(false);
    }
  }; // Create money buy boxes


  var givingData = givingType === 'single' ? singleGiving : regularGiving;
  return React.createElement(FormWrapper, null, React.createElement(GivingSelector, {
    givingType: givingType,
    changeGivingType: function changeGivingType(data) {
      return setGivingType(data);
    }
  }), React.createElement(Form, {
    onSubmit: function onSubmit(e) {
      return submitDonation(e, amountDonate, clientID, cartID, mbshipID, donateLink);
    }
  }, React.createElement(Legend, null, React.createElement(Text, {
    tag: "span",
    size: "l",
    weight: "bold"
  }, "Choose an amount to give")), React.createElement(OuterFieldset, null, React.createElement(MoneyBuys, null, givingData.moneybuys.map(function (_ref2, index) {
    var value = _ref2.value;
    return React.createElement(MoneyBox, {
      isSelected: amountDonate === value,
      amount: value,
      description: "\xA3".concat(value),
      setOtherAmount: function setOtherAmount() {
        return setAmountDonate(parseFloat(value));
      },
      key: value,
      name: "".concat(mbshipID, "--moneyBuy").concat(index + 1),
      id: "".concat(mbshipID, "--moneyBuy-box").concat(index + 1)
    });
  })), React.createElement(FormFieldset, null, React.createElement(Label, {
    size: "s",
    weight: "500"
  }, "Other amount"), React.createElement(AmountField, Object.assign({
    step: "0.01",
    name: "membership_amount",
    type: "number",
    inputBorderColor: isAmountValid(amountDonate) === false,
    label: "\xA3",
    errorMsg: "",
    id: "".concat(mbshipID, "--MoneyBuy-userInput"),
    showLabel: true
  }, rest, {
    max: "5000",
    min: "1",
    value: amountDonate,
    pattern: "[^[0-9]+([,.][0-9]+)?$]",
    placeholder: "0.00",
    onChange: function onChange(e) {
      return setAmountDonate(parseFloat(e.target.value));
    },
    "aria-label": "Input a different amount"
  }))), React.createElement(Button, {
    type: "submit"
  }, givingType === 'single' ? 'Donate once' : 'Donate monthly'), errorMsg && React.createElement(Error, {
    tag: "p"
  }, "Please enter an amount between \xA31 and \xA35,000, and up to 2 decimal places"), amountDonate >= 1 && moneyBuyCopy && React.createElement(Copy, {
    as: "p"
  }, moneyBuyCopy !== otherDescription ? React.createElement("strong", null, "\xA3".concat(amountDonate.toFixed(2), " could pay for ")) : React.createElement("strong", null, "\xA3".concat(amountDonate.toFixed(2), " ")), moneyBuyCopy))));
};

Signup.defaultProps = {
  data: {}
};
export default Signup;